<template>
<div class="modal fade" id="freezeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle"><strong>Freeze Course</strong></h5>
                <button role="button" class="border-0 p-0 bg-transparent" @click="closeModal">
                    <svg width="33" height="20" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.265 12.7989C12.5882 9.12215 9.10843 5.63707 5.62069 2.15997C5.09087 1.63016 4.60092 0.826188 3.97271 0.687628C3.07565 0.487784 1.8885 0.487506 1.15129 0.937172C0.0707674 1.59171 -0.0194419 2.83208 0.832571 3.87569C1.54081 4.7436 2.37412 5.51304 3.16752 6.30644C6.37571 9.52527 9.59189 12.7361 12.9625 16.1067C11.5494 17.5198 10.2827 18.7865 9.01334 20.0559C6.45066 22.6185 3.87733 25.1653 1.33594 27.7492C0.0745642 29.0319 0.00566136 30.3042 1.04933 31.3639C2.09299 32.4235 3.39725 32.3972 4.67194 31.1438C8.05427 27.8147 11.3967 24.4404 14.7524 21.0847C15.226 20.611 15.7024 20.1346 16.3437 19.4933C17.4859 20.6355 18.4896 21.6392 19.4933 22.6429C22.2756 25.4251 25.0471 28.2233 27.848 30.9869C29.2643 32.382 30.4914 32.4807 31.5719 31.3684C32.6443 30.264 32.5136 29.0848 31.0892 27.6444C27.8331 24.3617 24.5557 21.1003 21.2862 17.8308C20.807 17.3516 20.3304 16.875 19.7208 16.2654C20.2663 15.6613 20.6894 15.153 21.1577 14.6846C24.4655 11.3662 27.7893 8.06368 31.0891 4.73724C32.4889 3.32683 32.6377 2.08116 31.61 0.97894C30.5157 -0.195159 29.1795 -0.0890008 27.7239 1.356C23.961 5.08692 20.2168 8.84712 16.265 12.7989Z" fill="black" />
                    </svg>
                </button>
            </div>
            <div class="modal-body" v-if="currentStep === 1">
                <div class="text-muted text-center">
                    PKR {{ totalDeductionAmount }}
                </div>
                <div class="d-flex align-items-center mt-3 mb-3">
                    <v-select v-if="invoice && invoice.items && invoice.items.length > 0" v-model="selectedItemsStep1" :close-on-select="false" :options="invoice.items" label="item_name" :multiple="true" placeholder="Select Courses To Freeze" class="ms-2 w-75"></v-select>
                    <div>
                        <button v-if="selectedItemsStep1.length > 0" type="button" class="btn btn-outline-danger ms-2" style="border-radius: 30px;" @click="addItemsStep1"><i class="fa-solid fa-arrow-up"></i></button>
                    </div>
                </div>
                <table v-if="selectedItemsStep1.length > 0" class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Course</th>
                            <th>Fees</th>
                            <th>Paid</th>
                            <th>Deduction</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in selectedItemsStep1" :key="item.item_code">
                            <td>{{ item.item_name }}</td>
                            <td>{{ item.amount }}</td>
                            <td>
                                {{ paidAndRemainingAmountOfCourse(item.item_code) }}<br>
                            </td>
                            <td><input class="w-100 input-field-StdInfo" v-model="item.deduction" placeholder="Enter Amount" @input="validateAmount(item)"></td>
                            <td>
                                <div class="ms-1 mt-1">
                                    <button type="button" @click="deleteRow(index)" class="btn btn-outline-danger inputfield"><i class="fa-solid fa-trash"></i></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="amountExceed">
                    <p class="text-danger text-center">Deduction Amount Cannot Be Exceed Than The Paid Amount!</p>
                </div>
            </div>
            <div class="modal-body" v-else-if="currentStep === 2">
                <div class="text-muted text-center">
                    PKR {{ getTotalInvoiceItems }}
                    <p>Installments</p>
                </div>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Due Date</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(invoice,index) in invoice.payment_schedule" :key="invoice.name">
                            <td>
                                <datepicker v-model="invoice.due_date" format="yyyy-MM-dd" :disabled-dates="disabledDates" class="w-50" />
                            </td>
                            <td> <input v-model="invoice.payment_amount" class="input-field-StdInfo w-100" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" @click="prevStep" v-if="currentStep > 1">Prev</button>
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="closeModal()" v-else>Close</button>
                <button type="button" class="btn btn-outline-danger" @click="currentStep === 2 ? freezeAction() : nextStep()" :disabled="(currentStep === 2 && !areInstallmentsEqual) || (currentStep === 1 && (selectedItemsStep1.length <= 0 || isNextButtonDisabled || amountExceed))">
                    <i class="me-1 fa-solid" :class="{ 'fa-arrow-right': currentStep === 1}"></i>
                    <i class="me-1 fa-solid fa-check" v-if="currentStep === 2"></i>
                    {{ currentStep === 1 ? 'Next' : 'Freeze' }}
                    <b-spinner v-if="loading" small> </b-spinner>
                </button>

            </div>

        </div>
    </div>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import * as invoiceHelper from './../../store/invoiceHelper';
import * as LmsApiHelper from './../../store/LmsApiHelper';
import {
    mapState
} from 'vuex';
export default {
    name: 'FreezeModal',
    props: {
        invoice: Object,
        invoicePaymentDetail: Array,
        items: Array,
        invoiceId: String,
        customerName: String,
        userId:String
    },
    components: {
        Datepicker
    },
    data() {
        return {
            selectedItems: [],
            currentStep: 1,
            selectedItemsStep1: [],
            selectedItemsStep2: [],
            amountExceed: false,
            exceededAmount: 0,
            amountExceeded: false,
            loading: false
        };
    },
    methods: {
        closeModal() {
            this.selectedItemsStep1 = [];
            this.currentStep = 1;
            $('#freezeModal').modal('hide');
        },

        deleteRow(index) {
            if (index > -1) {
                this.selectedItemsStep1.splice(index, 1);
            }
        },
        paidAndRemainingAmountOfCourse(itemid) {
            const matchingItems = this.invoicePaymentDetail.filter(item => item.itemid === itemid);
            if (matchingItems.length > 0) {
                const totalAmount = matchingItems.reduce((sum, item) => sum + parseFloat(item.amount), 0);
                return totalAmount;
            } else {
                return 0;
            }
        },
        nextStep() {
            this.currentStep += 1;
        },
        addItemsStep1() {
            this.selectedItemsStep1.forEach(item => {
                const newItem = {
                    item_name: item.item_name,
                    amount: item.amount,
                    deduction: 0
                };
                this.selectedItems.push(newItem);
            });
        },
        prevStep() {
            this.currentStep -= 1;
        },
        validateAmount(item) {
            const inputAmount = parseFloat(item.deduction);
            const itemAmount = this.paidAndRemainingAmountOfCourse(item.item_code);
            if (inputAmount > itemAmount) {
                this.amountExceed = true;
            } else {
                this.amountExceed = false;
            }
        },
        async freezeAction() {
            console.log("Freeze Button Clicked");
            for (let i = 0; i < this.selectedItemsStep1.length; i++) {
                const item_pv_id = await invoiceHelper.getItemByItemName(this.selectedItemsStep1[i].item_code);
                console.log(item_pv_id);
                const response = await LmsApiHelper.invokedAccess(this.userId,item_pv_id.custom_product_variant_id,"Unenrolled");
                if(response === 401){
                    this.$toasted.error("You are already logged in.", {
            theme: "outline",
            duration: 3000,
            icon: "exclamation-triangle",
            position: "bottom-center",
        });
                    localStorage.clear();
                    this.$router.push('/login');
                    return;
                }
                await this.createPaymentDetail(this.invoiceId, this.selectedItemsStep1[i].item_code, this.selectedItemsStep1[i].deduction - this.paidAndRemainingAmountOfCourse(this.selectedItemsStep1[i].item_code), "Freeze");
                
            }
            await this.invoiceEdit();
        },
        async createPaymentDetail(invoiceId, itemId, amount, status) {
            this.loading = true;
            const payload = {
                invoiceid: invoiceId,
                itemid: itemId,
                amount: amount,
                status: status
            };
            try {
                const paymentDetail = await fetch(`${this.erp_api_url}api/resource/PaymentDetail`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                    body: JSON.stringify(payload)
                });
            } catch (error) {
                console.error("Error Creating Payment Detail", error);
            } finally {
                this.loading = false;
            }
        },
        async invoiceEdit() {
            const payment_schedule = this.invoice.payment_schedule.map(invoice => ({
                due_date: parseFloat(invoice.payment_amount) ? new Date(invoice.due_date).toISOString().split('T')[0] : new Date().toISOString().split()[0],
                payment_amount: parseFloat(invoice.payment_amount)
            }));

            const editItemAmount = this.invoice.items.map(item => {
                const selectedItem = this.selectedItemsStep1.find(selectedItem => selectedItem.item_code === item.item_code);
                const deduction = selectedItem ? parseFloat(selectedItem.deduction) : null;
                const newItem = {
                    item_code: item.item_code,
                    qty: 1,
                    is_free_item: item.is_free_item === true || item.is_free_item === 1 ? 1 : 0,
                };
                if (!item.is_free_item) {
                    newItem.rate = deduction !== null ? deduction : parseFloat(item.amount)
                }
                if (item.is_free_item) {
                    newItem.custom_due_date = new Date(item.custom_due_date).toISOString().split('T')[0];
                }
                return newItem;

            });

            const editInvoicePayload = {
                name: this.invoiceId,
                customer: this.customerName,
                posting_date: new Date().toISOString().split('T')[0],
                items: editItemAmount,
                payment_schedule: payment_schedule
            };
            console.log({
                editInvoicePayload
            });
            try {
                this.loading = true;
                const editInvoice = await fetch(`${this.erp_api_url}api/resource/Sales%20Invoice`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                    body: JSON.stringify(editInvoicePayload)
                });
                const editinvoiceResponse = await editInvoice.json();
                if (editinvoiceResponse && editinvoiceResponse.data != null) {
                    await invoiceHelper.editInvoiceStatus(editinvoiceResponse.data.name, 1);
                    const getPayment = await invoiceHelper.getPaymentByInvoice(this.invoiceId);
                    const getPaymentDetail = await invoiceHelper.getPaymentDetailByInvoiceId(this.invoiceId);
                    await invoiceHelper.editInvoiceStatus(this.invoiceId, 2);
                    if (getPayment && getPayment.length) {
                        console.log(getPayment.length);
                        console.log("Payments Detail length is: ", getPaymentDetail.length);
                        for (let i = 0; i < getPayment.length; i++) {
                            await invoiceHelper.editPayments(editinvoiceResponse.data.name, getPayment[i].name, getPayment[i].paid_amount, getPayment[i].mode_of_payment);
                            for (let i = 0; i < getPaymentDetail.length; i++) {
                                await invoiceHelper.editPaymentDetails(editinvoiceResponse.data.name, getPaymentDetail[i].name);
                            }
                        }
                        this.$router.push({
                            name: "StudentInformation",
                            query: {
                                invoice: editinvoiceResponse.data.name
                            },
                            path: '/Student/information'
                        })
                        // window.location.reload();
                    } else {
                        console.error('getPayment is undefined or has length 0');
                    }
                }
            } catch (error) {
                console.error("error editing invoice", error);
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        ...mapState(["erp_api_url","authorization_token"]),
        isNextButtonDisabled() {
            return this.selectedItemsStep1.some(item => !item.deduction);
        },
        totalDeductionAmount() {
            if (this.selectedItemsStep1 && this.selectedItemsStep1.length > 0) {
                return this.selectedItemsStep1.reduce((acc, deduction) => {
                    const courseDeduction = parseFloat(deduction.deduction);
                    if (!isNaN(courseDeduction)) {
                        return acc + this.paidAndRemainingAmountOfCourse(deduction.item_code) - courseDeduction;
                    }
                    return acc;
                }, 0);
            }
        },
        handleInvoiceTotals() {
            if (this.invoice && this.invoice.items && this.invoice.items.length > 0) {
                return this.invoice.items.reduce((acc, item) => acc + parseFloat(item.amount), 0);
            }
        },
        getTotalInvoiceItems() {
            return this.handleInvoiceTotals - this.totalFeesAmount;
        },
        totalFeesAmount() {
            return this.selectedItemsStep1.reduce((acc, fee) => acc + parseFloat(fee.amount) - parseFloat(fee.deduction), 0);
        },
        disabledDates() {
            const minDate = new Date();
            minDate.setDate(minDate.getDate() - 1);

            return {
                to: minDate
            };
        },
        areInstallmentsEqual() {
            if (this.currentStep === 2) {
                const totalInstallmentsAmount = this.invoice.payment_schedule.reduce((acc, installment) => {
                    return acc + parseFloat(installment.payment_amount) || 0;
                }, 0);
                return totalInstallmentsAmount === this.getTotalInvoiceItems;
            }
            return false;
        },
    },

}
</script>

<style scoped>
.input-field-StdInfo {
    padding: 2px 8px;
    border-radius: 7px;
    margin-bottom: 5px;
    border: 1px solid #dcd8d8;
}
</style>
